import PropTypes from "prop-types";
import classNames from "classnames";
import { quotationFlightShape } from "app/utils/propTypes";
import { Amount } from "app/components/ui/Amount/Amount";
import "./cabins-filter.scss";
import { FormattedMessage } from "react-intl";
import get from "lodash/get";
import { getCabinLabelMessageId } from "app/utils/i18nUtils";

const CabinsFilter = ({
	cabins = [],
	selectedCabin,
	onSelect,
	minUpgradePricesByCabin = {},
	includedFlight = {},
}) => {
	const tabHeaderNode = [];

	cabins.forEach(cabin => {
		const tabClass = classNames({
			"cabins-filter__header": true,
			"cabins-filter__header--selected": cabin === selectedCabin,
		});

		const minUpgradePricePerCabin = minUpgradePricesByCabin[cabin];

		const cabinMessageKey = getCabinLabelMessageId(cabin);

		tabHeaderNode.push(
			<div key={cabin} className={tabClass} onClick={() => onSelect(cabin)}>
				<div className="cabins-filter__label">
					<FormattedMessage id={cabinMessageKey} />
				</div>

				{get(includedFlight, "outbound.cabin") !== cabin && minUpgradePricePerCabin && (
					<div className="cabins-filter__upgradePrice">
						<Amount
							sign={minUpgradePricePerCabin > 0 ? "+" : undefined}
							signIsBold={false}
							value={minUpgradePricePerCabin}
							size="small"
							sizeMD="regular"
							signSize="xsmall"
						/>
					</div>
				)}
			</div>
		);
	});

	return (
		<div className="cabins-filter">
			<div className="cabins-filter__headers">{tabHeaderNode}</div>
		</div>
	);
};

CabinsFilter.propTypes = {
	includedFlight: quotationFlightShape,
	minUpgradePricesByCabin: PropTypes.object,
	cabins: PropTypes.arrayOf(PropTypes.string),
	selectedCabin: PropTypes.string,
	onSelect: PropTypes.func.isRequired,
};

export default CabinsFilter;
